import React, { useEffect, useState } from "react";
import { Sidebar } from "../../components/Sidebar";
import DaySection from "../../components/GreenMiles/HotelPage/DaySection";
import { useGlobalStaysFeed } from "../../components/GreenMiles/hooks/useGlobalStaysFeed";

const STAY_STATUS_OPTIONS = [
  { value: "", label: "Tous (sauf Waiting/No-show)" },
  { value: "IN_PROGRESS", label: "En cours" },
  { value: "STAND_BY", label: "Stand-by" },
  { value: "COMPLETED", label: "Terminés" },
  { value: "WAITING_FOR_GUEST", label: "En attente (Waiting for stay)" },
];

const GreenMilesStaysPage = () => {
  const [statusInput, setStatusInput] = useState("");
  const [activeStatus, setActiveStatus] = useState(null);

  const {
    orderedDays,
    staysByDay,
    eventsByDayStay,
    dateRange,
    setDateRange,
    isInitialLoading,
    isFetchingMore,
    error,
    hasMore,
    loaderRef,
    refetch,
  } = useGlobalStaysFeed({ status: activeStatus });

  const [startInput, setStartInput] = useState(dateRange.start || "");
  const [endInput, setEndInput] = useState(dateRange.end || "");

  useEffect(() => {
    setStartInput(dateRange.start || "");
  }, [dateRange.start]);

  useEffect(() => {
    setEndInput(dateRange.end || "");
  }, [dateRange.end]);

  const applyFilter = () => {
    setDateRange({
      start: startInput || null,
      end: endInput || null,
    });
    setActiveStatus(statusInput || null);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 overflow-hidden">
        <div className="h-full overflow-auto px-6 py-6 space-y-4">
          <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6">
            <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
              <div>
                <h1 className="text-2xl font-semibold text-gray-900">Séjours GreenMiles</h1>
                <p className="text-sm text-gray-500">
                  Suivi consolidé des séjours (exclusion par défaut des statuts Waiting for guest / No show)
                </p>
              </div>
              <button
                type="button"
                onClick={refetch}
                className="px-4 py-2 rounded-md border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50"
              >
                Actualiser
              </button>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <label className="text-sm font-medium text-gray-700">Du</label>
              <input
                type="date"
                value={startInput}
                onChange={(e) => setStartInput(e.target.value)}
                className="px-3 py-1 border border-gray-300 rounded text-sm"
              />
              <label className="text-sm font-medium text-gray-700">au</label>
              <input
                type="date"
                value={endInput}
                onChange={(e) => setEndInput(e.target.value)}
                className="px-3 py-1 border border-gray-300 rounded text-sm"
              />
              <label className="text-sm font-medium text-gray-700">Statut</label>
              <select
                value={statusInput}
                onChange={(e) => setStatusInput(e.target.value)}
                className="px-3 py-1 border border-gray-300 rounded text-sm bg-white"
              >
                {STAY_STATUS_OPTIONS.map((option) => (
                  <option key={option.value || "all"} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={applyFilter}
                className="px-4 py-2 text-white rounded-full text-sm font-semibold"
                style={{ backgroundColor: "#3B5543" }}
              >
                Valider
              </button>
            </div>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 rounded px-4 py-3 text-sm">
              {error}
            </div>
          )}

          {isInitialLoading && !error && (
            <div className="flex items-center text-gray-600 px-4 py-3">
              <div className="w-4 h-4 mr-2 border-2 border-gray-200 border-t-[#3B5543] rounded-full animate-spin" />
              Chargement des séjours...
            </div>
          )}

          {!isInitialLoading && orderedDays.length === 0 && !error && (
            <div className="bg-white border border-dashed border-gray-200 rounded-lg p-8 text-center text-gray-500">
              Aucun séjour trouvé pour la période sélectionnée.
            </div>
          )}

          {orderedDays.map((day) => (
            <DaySection
              key={day}
              day={day}
              stays={staysByDay[day] || []}
              eventsByStay={eventsByDayStay[day] || {}}
            />
          ))}

          <div ref={loaderRef} className="py-6 flex items-center justify-center">
            {isFetchingMore && (
              <div className="flex items-center text-gray-500 text-sm">
                <div className="w-4 h-4 mr-2 border-2 border-gray-200 border-t-[#3B5543] rounded-full animate-spin" />
                Chargement supplémentaire...
              </div>
            )}
            {!hasMore && !isInitialLoading && orderedDays.length > 0 && (
              <div className="text-xs text-gray-400">Tous les séjours disponibles ont été chargés</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GreenMilesStaysPage;

